const Action = {
  namespaced: true,
  state: {
    actions: [],
    loading: false
  },
  mutations: {
    updateActions: (state, value) => { state.actions = Object.assign([], value) },
    updateLoading: (state, value) => { state.loading = value },
    reset: (state, value) => {
      state.actions = Object.assign([])
    }
  },
  actions: {
    setActions: (context, payload) => context.commit('updateActions', payload),
    setLoading: (context, payload) => context.commit('updateLoading', payload),
    reset: (context, payload) => {
      context.commit('reset')
    }
  }
}

export default Action



// WEBPACK FOOTER //
// ./src/store/Action.js